module.exports = __webpack_public_path__ + "img/i_10_h.6b17fdd0.png";